
import React from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import PropTypes from 'prop-types'; 
import { Link } from "react-router-dom";

const TopCategory = (props) => {
  console.log(props); 

  return (
    <Link to={props.link}>
    <div className="feature-box text-center ">
      <div className="feature-bg">
        <div className="feature-header">
        <div className="feature-icon">
          <img src={props.image} alt="" />
        </div>
        <div className="feature-cont">
          <div className="feature-text">{props.title}</div>
        </div>
      </div>
      <p>{props.kat} Kategory</p>
      </div>
    </div>
    </Link>
  );
};
TopCategory.propTypes = {
  link: PropTypes.string.isRequired, // Define title as required string
  title: PropTypes.string.isRequired, // Define title as required string
  image: PropTypes.string.isRequired, // Define title as required string
  kat: PropTypes.number.isRequired, // Define title as required string
};
export default TopCategory;
